module.exports = __webpack_public_path__ + "img/category-gas.8585a7c2.svg";